import "./types.js";

/**
 * Translates API flag to DvFlag format
 * Decision tree for API data translation based on:
 * - access: true -> Feature display
 * - access: false + visibility_type: 'hide' -> No display (internal beta test)
 * - access: false + visibility_type: 'display' + reason: 'NO_CLIENT_PERMISSION' -> Display missing plan
 * - access: false + visibility_type: 'display' + reason: 'NO_USER_PERMISSION' -> Display missing permission
 *
 * @param {ApiFlag} apiFlag - The API flag object
 * @returns {DvFlag} The translated DvFlag object
 */
export const apiFlagTranslator = (apiFlag) => {
  const result = {
    access: apiFlag.access,
    status: apiFlag.status,
  };

  // If no access but should display
  if (!apiFlag.access && apiFlag.payload.visibility_type === "display") {
    if (apiFlag.fallback) {
      result.fallback =apiFlag.fallback
    }else{
      switch (apiFlag.reason) {
        case "NO_ROLE_PERMISSION":
          result.fallback = "no_role";
          break;
        case "NO_CLIENT_PERMISSION":
          result.fallback = "no_plan";
          break;
        case "NO_USER_PERMISSION":
          result.fallback = "no_permission";
          break;
      }
    }

  }

  return result;
};

/**
 * Translates a collection of API flags to DvFlags format
 *
 * @param {ApiFlags} flags - The API flags collection
 * @returns {DvFlags} The translated DvFlags collection
 */
export const apiFlagListTranslator = (flags) => {
  const result = {};

  for (const [key, apiFlag] of Object.entries(flags)) {
    result[key] = apiFlagTranslator(apiFlag);
  }

  return result;
};
